// Pod photo preview lightbox — click an uploaded-photo link in cart page or
// cart drawer to view it inline instead of downloading. Delegated listener on
// document so it covers dynamically-rendered drawer items too.
//
// Shopify CDN content-negotiates: browsers sending `Accept: image/webp` get a
// webp derivative (smaller, fine for on-screen preview), but the original file
// is stored intact. The "Download original" button fetches with `Accept: */*`
// so the production team always gets the full-quality source file.
(function () {
  function filenameFromUrl(url) {
    try { return decodeURIComponent(url.split('/').pop().split('?')[0]); }
    catch (e) { return 'photo'; }
  }

  function downloadOriginal(url, btn) {
    var original = btn.textContent;
    btn.textContent = 'Downloading…';
    btn.disabled = true;
    fetch(url, { headers: { Accept: '*/*' } })
      .then(function (r) { return r.blob(); })
      .then(function (blob) {
        var objUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objUrl;
        a.download = filenameFromUrl(url);
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(objUrl);
        btn.textContent = original;
        btn.disabled = false;
      })
      .catch(function () {
        // Fallback: open in a new tab if the blob fetch is blocked.
        window.open(url, '_blank');
        btn.textContent = original;
        btn.disabled = false;
      });
  }

  function openPreview(url) {
    var overlay = document.createElement('div');
    overlay.className = 'pod-lightbox';
    overlay.innerHTML =
      '<button class="pod-lightbox-close" aria-label="Close">&times;</button>' +
      '<div class="pod-lightbox-inner">' +
      '<img src="' + url + '" alt="Photo preview">' +
      '<button type="button" class="pod-lightbox-download">Download original</button>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    function close() {
      overlay.remove();
      document.body.style.overflow = '';
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.pod-lightbox-close').addEventListener('click', close);
    overlay.querySelector('.pod-lightbox-download').addEventListener('click', function (e) {
      e.stopPropagation();
      downloadOriginal(url, this);
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-pod-preview]');
    if (link) { e.preventDefault(); openPreview(link.href); }
  });
})();
